<template>
    <Teleport to="#vue-teleport-container">
        <div
            :key="key"
            v-if="show"
            @click="hide()"
            class="cursor-pointer fixed top-4 right-4 max-w-xs md:max-w-md lg:max-w-lg z-100 shadow-md"
        >
            <div
                v-if="flashStatus?.type === FlashStatusTypeEnum.Success"
                class="p-4 bg-emerald-600 text-gray-50 rounded-xl flex items-start gap-1"
            >
                <div class="w-9">
                    <Icon
                        name="circle-check"
                        class="w-6 h-6"
                    />
                </div>
                <div>
                    {{ flashStatus.message }}
                </div>
            </div>

            <div
                v-if="flashStatus?.type === FlashStatusTypeEnum.Error"
                class="p-4 bg-red-700 text-gray-50 rounded-xl flex items-start gap-1"
            >
                <div class="w-9">
                    <Icon
                        name="close-circle"
                        class="w-6 h-6"
                    />
                </div>
                <div>
                    {{ flashStatus.message }}
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
    import { onUnmounted } from 'vue'
    import useFlash from '@/Shared/Hook/useFlash'
    import Icon from '@/Shared/Component/Icon.vue'
    import { FlashStatusTypeEnum } from '@/Shared/AutoGenerated/Main'

    const { hide, flashStatus, show, key } = useFlash()

    onUnmounted(() => {
        hide()
    })
</script>
